// Before Login URL //

export const unAuthorizedUrl = ['login', 'forget_password', 'send_email', 'verify_otp', 'reset_password']


